import { GKButton, Grid2 } from "components";
import GKModal from "components/GKModal";
import GKTextArea from "components/GKTextBar";
import { useState } from "react";

interface Props {
  open: any;
  setOpen: any;
  index?: any;
  form: any;
}

const RebalanceRationale = ({ open, setOpen, form, index }: Props) => {
  const [textAreaText, setTextAreaText] = useState(
    form?.getValues(`stocks.${index}`)?.rationale,
  );

  return (
    <GKModal
      open={open}
      setOpen={setOpen}
      modalTitle="Rationale"
      footer={
        <GKButton
          variant="contained"
          onClick={() => {
            form.setValue(`stocks.${index}.rationale`, textAreaText);
            setOpen(false);
          }}
        >
          Save
        </GKButton>
      }
    >
      <Grid2 container>
        <Grid2 size={12}>
          <GKTextArea
            autoFocus
            placeholder="Enter Rationale"
            onChange={(e) => {
              setTextAreaText(e.target.value);
            }}
            value={textAreaText}
            name={`stocks.${index}.rationale`}
            minRows={5}
          />
        </Grid2>
      </Grid2>
    </GKModal>
  );
};

export default RebalanceRationale;
